import { mapState } from 'vuex'

import brandingMixin from '@/mixins/branding'

export default {
	mixins: [brandingMixin],
	computed: {
		...mapState('tours', ['footer']),
		getMenu () {
			const privacyPolicy = this.footer && this.footer.privacyPolicy
			const termsAndConditions = this.footer && this.footer.termsAndConditions

			return [
				{
					id: 'privacyPolicy',
					name: 'Privacy Policy',
					url: privacyPolicy ? privacyPolicy : 'https://homeontour.com/privacy'
				},
				{
					id: 'termsAndConditions',
					name: 'Terms and Conditions',
					url: termsAndConditions ? termsAndConditions : 'https://homeontour.com/terms'
				}
			]
		},
		poweredBy () {
			return this.footer && this.footer.poweredBy === false ? false : true;
		},
		currentYear () {
			const date = new Date()

			return date.getFullYear()
		}
	}
}
